import { styled } from '@mui/material/styles'
import React from 'react'

import UFO from '#/assets/ufo.svg'
import { Maps } from '#/components/Maps'
import Palette from '#/styles/Palette'

const Wrapper = styled('div')({
  display: 'flex',
  width: '100%',
  height: '400px',
  borderRadius: 16,
  overflow: 'hidden',
})

const EmptyWrapper = styled(Wrapper)({
  height: 'unset',
  minHeight: 400,
  backgroundColor: Palette.gray.light[100],
  fontSize: 16,
  padding: '0 32px 20px',
  textAlign: 'center',
  flexDirection: 'column',
  justifyContent: 'space-around',
  alignItems: 'center',
  color: Palette.gray.self[700],
})

const Img = styled('img')({
  width: 'auto',
  height: 350,
  padding: 25,
})

export const FindMyCowMap = ({ value }) => {
  if (!value) return null

  const { last_point, message } = value

  if (last_point?.lat && last_point?.lng) {
    return <Maps center={last_point} markers={{ find_my_cow: [value] }} zoom={17} />
  }

  return (
    <EmptyWrapper>
      <Img src={UFO} alt={message} />
      <span>{message}</span>
    </EmptyWrapper>
  )
}
